import { render, staticRenderFns } from "./pmGroups.vue?vue&type=template&id=45ccba9c"
import script from "./pmGroups.vue?vue&type=script&lang=js"
export * from "./pmGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports